export enum TagSize {
  XSmall = 0.25,
  Small = 0.5,
  Medium = 1,
  Large = 2,
  XLarge = 4,
}

export enum AnnotationSize {
  Small = 1,
  Medium = 2,
  Large = 4,
  XLarge = 8
}

export enum AnnotationDrawType {
  Eraser = 0,
  Polygon = 1,
  PolygonFreeHand = 2,
  LineString = 3,
  LineStringFreeHand = 4,
  Rectangle = 5,
  Circle = 6,
  Star = 7
}